import axios from 'axios';

export const getLocationList = () => {
  return axios.get(`/npi/api/catalog?ats_id=1&geonim_id=0&lang=AUTO`);
};

export const getRegionList = atsId => {
  return axios.get(`/npi/api/catalog?ats_id=${atsId}&geonim_id=0&lang=AUTO`);
};

export const getByAddressList = (address, atsId) => {
  return axios.get(
    `/npi/api/postcode/byAddress/${address}?lang=auto&filterByAtsId=${atsId}&size=5&from=0`,
  );
};
